import { Link } from "gatsby-plugin-react-i18next";
import * as React from 'react';
export default {
  Link,
  React
};